/* SafePati One — theme.js */
(function () {
  'use strict';
  const SP = window.SafePati || { routes: {}, strings: {}, moneyFormat: '{{amount}} ₺', cartDrawer: true };
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    const f = format || SP.moneyFormat || '{{amount}} ₺';
    const value = (cents / 100);
    const m = f.match(/\{\{\s*(\w+)\s*\}\}/);
    const key = m ? m[1] : 'amount';
    let out;
    switch (key) {
      case 'amount_no_decimals': out = fmt(value, 0, '.', ','); break;
      case 'amount_with_comma_separator': out = fmt(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = fmt(value, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = fmt(value, 2, "'", '.'); break;
      default: out = fmt(value, 2, ',', '.');
    }
    return f.replace(/\{\{\s*\w+\s*\}\}/, out);
    function fmt(n, dec, thou, decSep) {
      const parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.length > 1 ? parts.join(decSep) : parts[0];
    }
  }

  /* ---------- Toast ---------- */
  let toastT;
  function toast(msg) {
    const el = $('#Toast'); if (!el) return;
    el.textContent = msg; el.hidden = false;
    clearTimeout(toastT); toastT = setTimeout(() => { el.hidden = true; }, 2600);
  }

  /* ---------- Cart API ---------- */
  const Cart = {
    async get() { const r = await fetch(SP.routes.cart + '.js', { headers: { Accept: 'application/json' } }); return r.json(); },
    async add(id, quantity) {
      const r = await fetch(SP.routes.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id, quantity }] }) });
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || data.message || 'Sepete eklenemedi');
      return data;
    },
    async change(line, quantity) {
      const r = await fetch(SP.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
      return r.json();
    }
  };

  /* ---------- Cart drawer ---------- */
  const Drawer = {
    el: null,
    init() {
      this.el = $('#CartDrawer'); if (!this.el) return;
      $$('[data-cart-close]', this.el).forEach(b => b.addEventListener('click', () => this.close()));
      document.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); });
      $$('[data-cart-open]').forEach(a => a.addEventListener('click', e => { if (!SP.cartDrawer) return; e.preventDefault(); this.refresh().then(() => this.open()); }));
      this.el.addEventListener('click', e => this.onClick(e));
      this.el.addEventListener('change', e => { if (e.target.matches('[data-qty-input]')) this.setLine(e.target.closest('[data-line]'), parseInt(e.target.value, 10) || 0); });
    },
    open() { if (!this.el) return; this.el.classList.add('is-open'); this.el.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; },
    close() { if (!this.el) return; this.el.classList.remove('is-open'); this.el.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; },
    onClick(e) {
      const line = e.target.closest('[data-line]'); if (!line) return;
      const input = $('[data-qty-input]', line);
      if (e.target.closest('[data-qty-plus]')) this.setLine(line, (parseInt(input.value, 10) || 0) + 1);
      else if (e.target.closest('[data-qty-minus]')) this.setLine(line, Math.max(0, (parseInt(input.value, 10) || 0) - 1));
      else if (e.target.closest('[data-remove]')) this.setLine(line, 0);
    },
    async setLine(lineEl, qty) {
      const line = parseInt(lineEl.dataset.line, 10);
      lineEl.style.opacity = '.5';
      const cart = await Cart.change(line, qty);
      this.render(cart);
    },
    async refresh() { const cart = await Cart.get(); this.render(cart); return cart; },
    render(cart) {
      updateCount(cart.item_count);
      const body = $('[data-cart-items]', this.el); if (!body) return;
      const sub = $('[data-cart-subtotal]', this.el); if (sub) sub.textContent = formatMoney(cart.total_price);
      const cl = $('[data-cart-count-label]', this.el); if (cl) cl.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
      if (!cart.items.length) { body.innerHTML = '<p class="cart-drawer__empty">' + (SP.strings.empty || 'Sepetiniz boş.') + '</p>'; return; }
      body.innerHTML = cart.items.map((it, i) => {
        const img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1$2') + '" alt="" loading="lazy">' : '';
        const variant = it.product_has_only_default_variant ? '' : '<div class="cart-line__variant">' + esc(it.variant_title || '') + '</div>';
        return '<div class="cart-line" data-line="' + (i + 1) + '" data-key="' + it.key + '">' +
          '<a href="' + it.url + '" class="cart-line__img">' + img + '</a>' +
          '<div class="cart-line__info"><a href="' + it.url + '" class="cart-line__title">' + esc(it.product_title) + '</a>' + variant +
          '<div class="cart-line__row"><div class="qty qty--sm">' +
          '<button type="button" class="qty__btn" data-qty-minus aria-label="Azalt">−</button>' +
          '<input class="qty__input" type="number" min="0" value="' + it.quantity + '" data-qty-input aria-label="Adet">' +
          '<button type="button" class="qty__btn" data-qty-plus aria-label="Artır">+</button></div>' +
          '<div class="cart-line__price">' + formatMoney(it.final_line_price) + '</div>' +
          '<button type="button" class="cart-line__remove" data-remove aria-label="' + (SP.strings.remove || 'Kaldır') + '">✕</button>' +
          '</div></div></div>';
      }).join('');
    }
  };
  function esc(s) { return String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }
  function updateCount(n) { $$('[data-cart-count]').forEach(el => { el.textContent = n; el.classList.toggle('is-empty', !n); }); }

  /* ---------- Header ---------- */
  function initHeader() {
    const btn = $('[data-menu-toggle]'); const menu = $('#MobileMenu');
    if (btn && menu) btn.addEventListener('click', () => { const open = !menu.hidden; menu.hidden = open; btn.setAttribute('aria-expanded', String(!open)); });
  }

  /* ---------- Generic qty buttons (cart page) ---------- */
  function initQtyButtons() {
    document.addEventListener('click', e => {
      const plus = e.target.closest('[data-cart-page-plus]'); const minus = e.target.closest('[data-cart-page-minus]');
      if (!plus && !minus) return;
      const wrap = (plus || minus).closest('.qty'); const input = $('input', wrap);
      input.value = Math.max(0, (parseInt(input.value, 10) || 0) + (plus ? 1 : -1));
      const form = input.closest('form'); if (form) form.submit();
    });
  }

  /* ---------- Product section ---------- */
  function initProduct(section) {
    const form = $('[data-product-form]', section); if (!form) return;
    const jsonEl = $('[data-product-json]', section);
    let product = null; try { product = JSON.parse(jsonEl.textContent); } catch (e) { }
    const variantInput = $('[data-variant-id]', form);
    const qtyInput = $('[data-qty-input]', form);
    const atc = $('[data-atc]', form);
    const atcText = $('[data-atc-text]', atc);
    const spinner = $('.btn__spinner', atc);
    const errBox = $('[data-form-error]', form);
    const priceEls = $$('[data-price]', section);
    const compareEl = $('[data-compare-price]', section);
    const saveBadge = $('[data-save-badge]', section);
    const tiersWrap = $('[data-tiers]', section);
    let currentVariant = product ? (product.variants.find(v => String(v.id) === variantInput.value) || product.variants[0]) : null;

    /* qty +/- */
    section.addEventListener('click', e => {
      if (e.target.closest('[data-qty-plus]')) { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; syncSticky(); }
      if (e.target.closest('[data-qty-minus]')) { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); syncSticky(); }
    });

    /* variant picker */
    const optionInputs = $$('[data-option-input]', section);
    optionInputs.forEach(inp => inp.addEventListener('change', onVariantChange));
    function onVariantChange() {
      if (!product) return;
      const selected = [];
      $$('.variant-picker__group', section).forEach((g, i) => { const c = $('input:checked', g); selected[i] = c ? c.value : null; const lbl = $('[data-option-value]', g); if (lbl && c) lbl.textContent = c.value; });
      const v = product.variants.find(v => selected.every((val, i) => v.options[i] === val));
      currentVariant = v || null;
      renderVariant();
      if (v) { const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url); }
    }
    function renderVariant() {
      if (!currentVariant) { atc.disabled = true; atcText.textContent = SP.strings.unavailable || 'Mevcut değil'; return; }
      variantInput.value = currentVariant.id;
      priceEls.forEach(el => el.textContent = formatMoney(currentVariant.price));
      const cmp = currentVariant.compare_at_price;
      if (compareEl) { if (cmp && cmp > currentVariant.price) { compareEl.textContent = formatMoney(cmp); compareEl.classList.remove('hidden'); if (saveBadge) { saveBadge.textContent = '-' + Math.round((cmp - currentVariant.price) * 100 / cmp) + '%'; saveBadge.classList.remove('hidden'); } } else { compareEl.classList.add('hidden'); if (saveBadge) saveBadge.classList.add('hidden'); } }
      if (currentVariant.available) { atc.disabled = false; atcText.textContent = atc.dataset.label || atcText.dataset.label || atcText.textContent; } else { atc.disabled = true; atcText.textContent = SP.strings.soldOut || 'Tükendi'; }
      const stickyBtn = $('[data-sticky-atc-btn]', section); if (stickyBtn) stickyBtn.disabled = !currentVariant.available;
      if (tiersWrap) { tiersWrap.dataset.basePrice = currentVariant.price; renderTiers(); }
      /* galeriyi varyant görseline kaydır */
      if (currentVariant.featured_media && currentVariant.featured_media.id) Gallery.goToMedia(section, currentVariant.featured_media.id);
    }
    if (atcText) atcText.dataset.label = atcText.textContent.trim();

    /* tiers */
    function renderTiers() {
      if (!tiersWrap) return;
      const base = parseInt(tiersWrap.dataset.basePrice, 10) || 0;
      $$('.tier', tiersWrap).forEach(t => {
        const inp = $('input', t); const d = parseFloat(inp.dataset.discount) || 0;
        const unit = Math.round(base * (1 - d / 100));
        const u = $('[data-tier-unit]', t); if (u) u.textContent = formatMoney(unit);
        const o = $('[data-tier-old]', t); if (o) o.textContent = formatMoney(base);
        t.classList.toggle('is-selected', inp.checked);
      });
    }
    if (tiersWrap) {
      tiersWrap.addEventListener('change', e => {
        const inp = e.target.closest('[data-tier]'); if (!inp) return;
        qtyInput.value = parseInt(inp.value, 10) || 1; syncSticky(); renderTiers();
      });
      const checked = $('[data-tier]:checked', tiersWrap); if (checked) { qtyInput.value = parseInt(checked.value, 10) || 1; }
      renderTiers();
    }

    /* add to cart */
    form.addEventListener('submit', async e => {
      e.preventDefault(); await addToCart();
    });
    async function addToCart() {
      if (!variantInput.value) return;
      const qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      atc.classList.add('is-loading'); atc.disabled = true; if (spinner) spinner.hidden = false; if (errBox) errBox.hidden = true;
      try {
        await Cart.add(parseInt(variantInput.value, 10), qty);
        if (SP.cartDrawer && Drawer.el) { await Drawer.refresh(); Drawer.open(); }
        else { location.href = SP.routes.cart; return; }
        toast(SP.strings.added || 'Sepete eklendi');
      } catch (err) {
        if (errBox) { errBox.textContent = err.message; errBox.hidden = false; }
      } finally { atc.classList.remove('is-loading'); atc.disabled = false; if (spinner) spinner.hidden = true; }
    }

    /* sticky bar */
    const sticky = $('[data-sticky-atc]', section);
    if (sticky) {
      const sQty = $('[data-sticky-qty]', sticky);
      $('[data-sticky-plus]', sticky).addEventListener('click', () => { sQty.value = (parseInt(sQty.value, 10) || 1) + 1; qtyInput.value = sQty.value; });
      $('[data-sticky-minus]', sticky).addEventListener('click', () => { sQty.value = Math.max(1, (parseInt(sQty.value, 10) || 1) - 1); qtyInput.value = sQty.value; });
      sQty.addEventListener('change', () => { qtyInput.value = Math.max(1, parseInt(sQty.value, 10) || 1); });
      $('[data-sticky-atc-btn]', sticky).addEventListener('click', () => addToCart());
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(entries => {
          const ent = entries[0];
          const show = !ent.isIntersecting && ent.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', String(!show)); document.body.classList.toggle('has-sticky-visible', show);
        }, { threshold: 0 });
        io.observe(atc);
      }
    }
    function syncSticky() { const s = $('[data-sticky-qty]', section); if (s) s.value = qtyInput.value; }

    /* countdown */
    $$('[data-countdown]', section).forEach(initCountdown);
    Gallery.init(section);
    renderVariant();
  }

  /* ---------- Countdown ---------- */
  function initCountdown(el) {
    const timer = $('[data-timer]', el); if (!timer) return;
    const mode = el.dataset.mode; let end;
    if (mode === 'fixed' && el.dataset.until) { end = new Date(el.dataset.until.replace(' ', 'T')).getTime(); }
    else {
      const hours = parseInt(el.dataset.hours, 10) || 48; const key = 'sp_countdown_end';
      try { end = parseInt(localStorage.getItem(key), 10); } catch (e) { }
      if (!end || end < Date.now()) { end = Date.now() + hours * 3600 * 1000; try { localStorage.setItem(key, String(end)); } catch (e) { } }
    }
    if (!end || isNaN(end)) return;
    const d = $('[data-d]', timer), h = $('[data-h]', timer), m = $('[data-m]', timer), s = $('[data-s]', timer);
    const pad = n => String(n).padStart(2, '0');
    function tick() {
      let diff = Math.max(0, end - Date.now());
      const days = Math.floor(diff / 864e5); diff -= days * 864e5;
      const hrs = Math.floor(diff / 36e5); diff -= hrs * 36e5;
      const mins = Math.floor(diff / 6e4); diff -= mins * 6e4;
      const secs = Math.floor(diff / 1e3);
      if (d) d.textContent = days;
      h.textContent = pad(hrs); m.textContent = pad(mins); s.textContent = pad(secs);
    }
    tick(); setInterval(tick, 1000);
  }

  /* ---------- Gallery ---------- */
  const Gallery = {
    init(section) {
      const g = $('[data-gallery]', section); if (!g) return;
      const vp = $('[data-gallery-viewport]', g); const thumbs = $$('[data-thumb]', g); const dots = $$('[data-gallery-dots] span', g);
      if (!vp) return;
      thumbs.forEach(t => t.addEventListener('click', () => this.goTo(g, parseInt(t.dataset.index, 10))));
      let raf;
      vp.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(() => { const i = Math.round(vp.scrollLeft / vp.clientWidth); this.setActive(g, i); }); });
    },
    goTo(g, i) { const vp = $('[data-gallery-viewport]', g); vp.scrollTo({ left: i * vp.clientWidth, behavior: 'smooth' }); this.setActive(g, i); },
    goToMedia(section, mediaId) { const g = $('[data-gallery]', section); if (!g) return; const slide = $('[data-slide][data-media-id="' + mediaId + '"]', g); if (slide) this.goTo(g, parseInt(slide.dataset.index, 10)); },
    setActive(g, i) {
      $$('[data-thumb]', g).forEach(t => { const on = parseInt(t.dataset.index, 10) === i; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', String(on)); if (on && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest' }); });
      $$('[data-gallery-dots] span', g).forEach((d, di) => d.classList.toggle('is-active', di === i));
    }
  };

  /* ---------- Simple sliders (testimonials) ---------- */
  function initSliders() {
    $$('[data-slider].is-slider').forEach(track => {
      const dotsWrap = track.parentElement.querySelector('[data-slider-dots]'); if (!dotsWrap) return;
      const cards = $$('.tcard', track); if (!cards.length) return;
      const perView = () => Math.max(1, Math.round(track.clientWidth / cards[0].offsetWidth));
      function build() {
        const pages = Math.max(1, Math.ceil(cards.length / perView()));
        dotsWrap.innerHTML = Array.from({ length: pages }, (_, i) => '<span data-page="' + i + '"' + (i === 0 ? ' class="is-active"' : '') + '></span>').join('');
      }
      build();
      dotsWrap.addEventListener('click', e => { const s = e.target.closest('[data-page]'); if (!s) return; track.scrollTo({ left: parseInt(s.dataset.page, 10) * track.clientWidth, behavior: 'smooth' }); });
      track.addEventListener('scroll', () => { const p = Math.round(track.scrollLeft / track.clientWidth); $$('span', dotsWrap).forEach((d, i) => d.classList.toggle('is-active', i === p)); });
      window.addEventListener('resize', build);
    });
  }

  /* ---------- Scroll to top links ---------- */
  function initScrollTop() {
    $$('[data-scroll-top]').forEach(a => { if (!a.getAttribute('href') || a.getAttribute('href') === '#') a.addEventListener('click', e => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }); });
  }

  /* ---------- Boot ---------- */
  function boot() {
    Drawer.init(); initHeader(); initQtyButtons(); initSliders(); initScrollTop();
    $$('[data-product-section]').forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* Theme editor: re-init on section load */
  document.addEventListener('shopify:section:load', e => { const s = e.target; if (s.querySelector('[data-product-section]')) initProduct(s.querySelector('[data-product-section]')); initSliders(); });
})();
